import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["map"]

  async connect() {
    try {
      // Attendre que Google Maps soit chargé
      while (typeof google === 'undefined') {
        await new Promise(resolve => setTimeout(resolve, 100))
      }
      this.initMap()
    } catch (error) {
      console.error("Erreur lors de l'initialisation de Google Maps:", error)
    }
  }

  async initMap() {
    const mapElement = document.getElementById('google-map')
    if (!mapElement) return

    const lat = parseFloat(mapElement.dataset.latitude) || 46.227638
    const lng = parseFloat(mapElement.dataset.longitude) || 2.213749
    const poiName = mapElement.dataset.name || 'Mon établissement'

    // Charger la bibliothèque marker
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")

    const map = new google.maps.Map(mapElement, {
      center: { lat, lng },
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: '8f52f5c1c5f07f0e'
    })

    const marker = new AdvancedMarkerElement({
      map,
      position: { lat, lng },
      title: poiName,
      gmpDraggable: true
    })

    // Créer le label
    const label = new google.maps.InfoWindow({
      content: `<div style="
        padding: 4px 8px;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
      ">${poiName}</div>`,
      pixelOffset: new google.maps.Size(0, -10),
      disableAutoPan: true
    })

    // Afficher le label
    label.open(map, marker)

    // Mettre à jour la position du label lors du déplacement
    marker.addListener('position_changed', () => {
      label.open(map, marker)
    })

    marker.addListener('dragend', () => {
      const position = marker.position
      const latitude = position.lat
      const longitude = position.lng

      const latitudeField = document.getElementById('poi_attributes_latitude')
      const longitudeField = document.getElementById('poi_attributes_longitude')

      if (latitudeField && longitudeField) {
        latitudeField.value = latitude
        longitudeField.value = longitude
      }
    })
  }
}